/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useState } from "react";
import { InlineEdit } from "../../components/InlineEdit";
import { Button } from "../../components/Button";
import { useParams } from "react-router-dom";
import useSaveTemplate from "../../utils/customHooks";
import { SpinnerOverlay } from "../../utils/SpinnerOverlay";

export const Sw02: React.FC = () => {
  const { pdfNameFromUrl } = useParams<{ pdfNameFromUrl: string }>();
  const [text1, setText1] = useState<string>("Zaczarowana Księga Baśni");
  // TODO to nie jest ten font!!!
  const [text2, setText2] = useState<string>("Majeczki Nowak");
  const [text3, setText3] = useState<string>("Z cieplutkimi życzeniami");
  const [text4, setText4] = useState<string>("Babcia Zosia i Dziadek Tomasz");
  const text1BasicSize = 53;
  const text2BasicSize = 86;
  const text3BasicSize = 33;
  const text4BasicSize = 33;
  const [fontSizeText1, setFontSizeText1] = useState<number>(text1BasicSize);
  const [fontSizeText2, setFontSizeText2] = useState<number>(text2BasicSize);
  const [fontSizeText3, setFontSizeText3] = useState<number>(text3BasicSize);
  const [fontSizeText4, setFontSizeText4] = useState<number>(text4BasicSize);
  const { saveTemplate, isSaving } = useSaveTemplate();

  const pdfWidth = "250mm"; // PDF width in mm
  const pdfHeight = "300mm"; // PDF height in mm
  const maxWidth = 800; // Maximum width for text
  const adjustFontSize = (
    text: string,
    currentFontSize: number,
    maxFontSize: number,
    minFontSize: number
  ) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    if (context) {
      let newFontSize = currentFontSize;
      context.font = `${newFontSize}px 'ComicSans'`;
      let textWidth = context.measureText(text).width;

      while (textWidth > maxWidth && newFontSize > minFontSize) {
        newFontSize -= 1;
        context.font = `${newFontSize}px 'ComicSans'`;
        textWidth = context.measureText(text).width;
      }

      while (textWidth < maxWidth * 0.9 && newFontSize < maxFontSize) {
        newFontSize += 1;
        context.font = `${newFontSize}px 'ComicSans'`;
        textWidth = context.measureText(text).width;
      }

      return newFontSize;
    }

    return currentFontSize;
  };

  useEffect(() => {
    setFontSizeText1(adjustFontSize(text1, fontSizeText1, text1BasicSize, 10));
  }, [text1]);

  useEffect(() => {
    setFontSizeText2(adjustFontSize(text2, fontSizeText2, text2BasicSize, 10));
  }, [text2]);

  useEffect(() => {
    setFontSizeText3(adjustFontSize(text3, fontSizeText3, text3BasicSize, 10));
  }, [text3]);

  useEffect(() => {
    setFontSizeText4(adjustFontSize(text4, fontSizeText4, text4BasicSize, 10));
  }, [text4]);

  const handleSave = () => {
    saveTemplate(
      "printable-content",
      {
        pdfWidth: pdfWidth, // PDF width in mm
        pdfHeight: pdfHeight, // PDF height in mm
        pdfNameFromUrl: pdfNameFromUrl,
      },
      null, // No image provided
      false // Disable the image requirement
    );
  };

  return (
        <div style={{
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff", padding: "80px",
      position: "relative",
    }}>
      {/* Spinner Overlay */}
      <SpinnerOverlay isVisible={isSaving} />

      <div style={{ position: "absolute", top: "20px", left: "20px" }}>
        <Button onClick={handleSave} disabled={isSaving}>
          {isSaving ? "Zapisywanie..." : "Zapisz"}
        </Button>
      </div>

      <div
        id="printable-content"
        style={{
          position: "relative",
          width: pdfWidth,
          height: pdfHeight,
          fontFamily: "Cardo-Regular, OliviaRegular, MonotypeCorsiva, GreatVibes",
          backgroundColor: "#ffffff",
          margin: "auto",
        }}
      >
        <div className="sw-01-text-wrapper" style={{}}>
          <InlineEdit
            value={text1}
            setValue={setText1}
            style={{
              fontSize: `${fontSizeText1}px`,
              lineHeight: `${fontSizeText1}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '111px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'Cardo-Regular',
              color: "#010101",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          />
          <InlineEdit
            value={text2}
            setValue={setText2}
            style={{
              fontSize: `${fontSizeText2}px`,
              lineHeight: `${fontSizeText2}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              top: '186px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'GreatVibes',
              color: "#010101",
              zIndex: "12",
              textAlign: "center",
              fontWeight: "400",
            }}
          />
          <InlineEdit
            value={text3}
            setValue={setText3}
            style={{
              fontSize: `${fontSizeText3}px`,
              lineHeight: `${fontSizeText3}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '100px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'Cardo-Regular',
              color: "#010101",
              zIndex: "12",
              textAlign: "right",
              fontWeight: "400",
            }}
          />

          <InlineEdit
            value={text4}
            setValue={setText4}
            style={{
              fontSize: `${fontSizeText4}px`,
              lineHeight: `${fontSizeText4}px`,
              width: `${maxWidth}px`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              position: 'absolute',
              bottom: '65px',
              margin: 'auto',
              left: '0',
              right: '0',
              fontFamily: 'Cardo-Regular',
              color: "#010101",
              zIndex: "12",
              textAlign: "right",
              fontWeight: "400",
            }}
          />
        </div>

        <img
          src="/images/Basnie SW02.png"
          style={{ width: "100%", height: "100%", position: 'absolute', top: '0', left: '0' }}
        />
      </div>
    </div>
  );
};
